export default [{
    path: '/messageries',
    name: 'messageries',
    component: () => import('@/views/messageries/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
  {
    path: '/messageries/:folder',
    name: 'messageries-folder',
    component: () => import('@/views/messageries/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'messageries',
    },
    beforeEnter(to, _, next) {
      // if (['Message', 'Tache', 'echeance', 'RendezVous', 'Rappel', 'Notes'].includes(to.params.folder)) next()
      if (['sent', 'starred'].includes(to.params.folder)) next()
      else next({
        name: 'error-404'
      })
    },
  },
  {
    path: '/messageries/label/:label',
    name: 'messageries-label',
    component: () => import('@/views/messageries/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'messageries',
    },
    beforeEnter(to, _, next) {
      if (['Reseaux', 'Assureurs', 'Clients', 'Comptabilité'].includes(to.params.label)) next()
      else next({
        name: 'error-404'
      })
    },
  },
]